export default "__VITE_ASSET__CFRBbE9D__"